import {
  GET_MEETINGS_SUCCESS,
  GET_MEETINGS_FAIL,
  ADD_MEETING_SUCCESS,
  ADD_MEETING_FAIL,
  UPDATE_MEETING_SUCCESS,
  UPDATE_MEETING_FAIL,
  DELETE_MEETING_SUCCESS,
  DELETE_MEETING_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  meetings: [],
  users: [],
  departments: [],
  success: null,
  error: null,
  loading: false
};

const meetings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MEETINGS_SUCCESS:
      return {
        ...state,
        meetings: action.payload[0],
        users: action.payload[1],
        departments: action.payload[2],
      };
    case GET_MEETINGS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_MEETING_SUCCESS:
      return {
        ...state,
        meetings: [...state.meetings, action.payload],
        success: { data: "success" },
      }
    case ADD_MEETING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case UPDATE_MEETING_SUCCESS:
      return {
        ...state,
        meetings: state.meetings.map(service =>
          service._id.toString() === action.payload._id.toString()
            ? { service, ...action.payload }
            : service
        ),
        success: { data: "success" },
      }
    case UPDATE_MEETING_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case DELETE_MEETING_SUCCESS:
      return {
        ...state,
        meetings: state.meetings.filter(
          service => service._id.toString() !== action.payload._id.toString()
        ),
      }
    case DELETE_MEETING_FAIL:
      return {
        ...state,
        error: action.payload,
      } 
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
};

export default meetings;
